import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import cx from 'classnames';
import { createComponent, PropTypes } from "../../../wayin-react";
import { sizes, icons, font } from "../../../enums";
import { whitelistStyles } from "../../core/hoc";
import Icon from "../../core/icon";
import Header from "../../core/header";
var QuickAction = createComponent({
  displayName: 'QuickAction',
  propTypes: {
    icon: PropTypes.oneOf(icons.ALL).isRequired,
    title: PropTypes.string.isRequired,
    byline: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    layout: PropTypes.oneOf(['horizontal', 'vertical']),
    isDisabled: PropTypes.bool,
    size: PropTypes.oneOf([sizes.X4, sizes.X5, sizes.X6, sizes.X7, sizes.X8])
  },
  defaultProps: {
    byline: undefined,
    value: undefined,
    id: undefined,
    layout: 'horizontal',
    isDisabled: false,
    size: sizes.X5
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  handlers: {
    handleClick: function handleClick(p) {
      return function (e) {
        if (!p.isDisabled) p.onClick(e, {
          value: p.value || p.title,
          id: p.id
        });
      };
    }
  },
  render: function render(p) {
    var _cx;

    var _mainCx = cx((_cx = {
      ck: true,
      'quick-action': true,
      'quick-action--inverted': p.isInverted
    }, _cx["quick-action--layout-" + p.layout] = true, _cx["quick-action--size-" + p.size] = true, _cx['quick-action--disabled'] = p.isDisabled, _cx));

    var _iconSize = sizes.X7;

    switch (p.size) {
      case sizes.X4:
        _iconSize = sizes.X6;
        break;

      case sizes.X5:
        _iconSize = sizes.X7; // default

        break;

      case sizes.X6:
      case sizes.X7:
      case sizes.X8:
        _iconSize = sizes.X8;
        break;
    }

    var _iconProps = _extends({
      name: p.icon,
      size: _iconSize,
      isDisabled: p.isDisabled
    }, p.isInverted && {
      color: 'white'
    });

    return /*#__PURE__*/React.createElement("div", {
      className: _mainCx,
      onClick: p.handleClick,
      style: p.style
    }, /*#__PURE__*/React.createElement("div", {
      className: "quick-action-icon"
    }, /*#__PURE__*/React.createElement(Icon, _iconProps)), /*#__PURE__*/React.createElement("div", {
      className: "quick-action-content"
    }, /*#__PURE__*/React.createElement(Header, {
      text: p.title,
      byline: p.byline,
      size: p.size,
      font: {
        family: font.families.SYSTEM
      },
      isDisabled: p.isDisabled
    })));
  }
});
export var PrivateQuickAction = QuickAction;
export default whitelistStyles()(QuickAction);
//# sourceMappingURL=index.js.map